import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PersonalLoan from "../../../../../../src/Images/NewUI/24hours.webp";
import Credit from "../../../../../assets/cred.png";
// Removed - data now comes from props
// import { getDocumentStatus, CreditAssist } from "../../../../../Redux/Manual_Kyc_Details/action";
import {
  notifyVisitorEvent
} from "../../../../../Redux/ApplyLoan/action";


const UnderReview = ({ user, documentStatus }) => {
  const [superAppScreen, setSuperAppScreen] = useState(null);

  useEffect(() => {
    // Use props data instead of API call
    if (documentStatus) {
      setSuperAppScreen(documentStatus?.super_app_screen);
    }
  }, [documentStatus]);

  // Removed - data now comes from props
  // Removed - CreditAssist function not being used
  

  return (
    <div className="cardstructure-super-app container-super-app">
      {/* {superAppScreen !== "NTC" && superAppScreen !== "WRONG_INFO" && (
        <img
          width={126}
          height={28}
          src={PersonalLoansuperapp}
          className="superapplable"
          alt="Super App Loan"
        />
      )} */}
      <div className="flex_row justifycontent pd-top-20">
        <div className="flex_row">
          { superAppScreen !== "NTC" && superAppScreen !== "WRONG_INFO" ? (
            <>
              <div>
                <img width={72} height={35} src={PersonalLoan} alt="Personal Loan" />
              </div>
              <div className="textalignleft">
                <span className="underreviewfont">Your application is under review!</span>
                <br />
                <span className="underreviewfontbelow">
                  We're evaluating your details for <br /> loan approval.
                </span>
              </div>
            </>
          ) : (
            <div className="majorAmountdiv-superapp">
              <div className="notification-container">
                <div className="notification-content flex align-center">
                  <div className="icon">
                    <img src={Credit} alt="Icon" width="30" height="30" className={superAppScreen !== "NTC" && "mb-25"} />
                  </div>
                  <div className="message ml-10">
                    {superAppScreen !== "NTC" ? (
                      <>
                        <span className="error-text">
                          <span style={{ color: "#FF0000" }}>Oops!</span> Some details seem incorrect.
                        </span>
                        <br />
                        <span className="guidance-text">Need help?  Get guidance to improve<br />your credit score.</span>
                      </>
                    ) : (
                      <>
                        <span className="error-text">
                          <span style={{ color: "#FC6603" }}>Hey!</span> You're New to Credit
                        </span>
                        <br />
                        <span className="guidance-text">Let's build a strong credit score.</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      { superAppScreen !== "NTC" && superAppScreen !== "WRONG_INFO" ?

      ""
      :
      ""
      
    //   <span 
    //   onClick={() => creditAssistRedirection(superAppScreen !== "NTC" ? "Try Now →" : "Get Started →")} 
    //   className="try-now-btn ntcbtn"
    // >
    //   {superAppScreen !== "NTC" ? "Try Now →" : "Get Started →"}
    // </span>
}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, { notifyVisitorEvent })(UnderReview);